import feedType from './feedTypes';

const texts = {
  [feedType.WORKOUT_COMPLETE]: 'Completed Workouts',
  [feedType.CUSTOM_WORKOUT]: 'Custom Workouts',
  [feedType.NEED_NEW_WORKOUTS]: 'Need new Workouts',
  [feedType.NEED_NEW_MEAL_PLAN]: 'Need new Meal plans',
  [feedType.TRACKED_ACTIVITY]: 'Tracked Activities',
  [feedType.DAILY_SUMMARY]: 'Daily Summary',
  [feedType.ARCHIVED]: 'Deleted Notifications',
  [feedType.CHECK_IN]: 'Check-in',
  [feedType.CLIENT_STATUS]: 'Client Status',
  [feedType.SPECIAL]: 'Special Reminders',
  [feedType.PAUSE_REQUEST]: 'Pause Requests',
  [feedType.WORKOUT_FEEDBACK_REQUEST]: 'Feedback Requested',
  [feedType.DISENGAGED_CLIENT]: 'Disengaged Clients',
  [feedType.COACH_TASK]: 'Coach Tasks',
  [feedType.TODO]: 'To-do',
  [feedType.USER_PREFERENCE_CHANGE]: 'Preference Change',
  [feedType.WORKOUT_CONFLICT_REVIEW]: 'Workout Conflicts',
};

export default texts;
